











import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({
  componentName: 'AddUserDialogBody'
})
export default class AddUserDialogBody extends Vue {
  @Prop()
  submit!: Function

  form = {
    userid: ''
  }

  rules = {
    userid: [
      { required: true, message: '请输入成员的WPS ID', trigger: ['blur', 'change'] },
      { type: 'number', message: '格式不正确', trigger: ['blur', 'change'] }
    ]
  }

  onOk () {
    const el: any = this.$refs['form']
    el.validate((valid: any) => {
      if (valid) {
        this.submit(this.form.userid)
      }
    })
  }

  mounted () {
    this.$on('onOk', this.onOk)
  }
}
